import { http } from '@/utils/request';

class API {
    static login(data) {
        return http.post('/userApp/patient/wxLoginPhone', data, {system: 8});
    }
    static verifyCode(data) {
        return http.post('/base/sms/seed', data);
    }
    static sleepSelfAssessment(data) {
        return http.post('/userApp/sleepSelfAssessment/pageList', data);
    }
    static userInfoRequest(data) {
        return http.get('/userApp/patient/load', { params: data });
    }
    //配置信息
    static getConfiguration(data) {
        return http.post('/userApp/sleepAssessmentTask/assessmentTaskInfo', data);
    }

    //配置信息
    static getQuery(data) {
        return http.get('/userApp/sleepAssessment/assessmentInfo', { params: data });
    }
    static submitQuery(data) {
        return http.post('/userApp/clientAssessment/submit', data);
    }
    static getResult(data) {
        return http.post('/userApp/clientAssessment/getClientResult', data);
    }
}

export default API;
